import { useTranslation } from 'react-i18next';

import type { OptionTemplateProps } from '~/chords/DropdownSingleSelect/types';
import { Spinner } from '~/chords/Spinner';

export function LoadingOptionTemplate({
  option,
  isTrigger,
}: OptionTemplateProps) {
  const { t } = useTranslation('chords');

  if (isTrigger) {
    return (
      <span className="truncate pl-md text-default">
        {option.label || option.value}
      </span>
    );
  }

  return (
    <div className="flex w-full items-center justify-between gap-md">
      <span className="text-emphasis-stronger">{t('loadingWithEllipsis')}</span>
      <span>
        <Spinner size="sm" />
      </span>
    </div>
  );
}

LoadingOptionTemplate.displayName = 'LoadingOptionTemplate';
